import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../../public-theme.css';
import '../../public-theme-compat.css';

const INTERNAL_PATH_PREFIXES = [
  '/launcher',
  '/staff',
  '/messages',
  '/analytics',
  '/bookings',
  '/admin',
  '/settings',
  '/login',
  '/activate-account',
  '/reset-password',
  '/account-security',
  '/kiosk',
  '/consent',
];

const DestructiveRouteGuard = () => {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname.toLowerCase();
    const isInternal = INTERNAL_PATH_PREFIXES.some(prefix => pathname === prefix || pathname.startsWith(`${prefix}/`));
    const isPublic = !isInternal;

    document.documentElement.classList.toggle('public-site', isPublic);
    document.body.classList.toggle('public-site', isPublic);

    return () => {
      document.documentElement.classList.remove('public-site');
      document.body.classList.remove('public-site');
    };
  }, [location.pathname]);

  useEffect(() => {
    const protect = event => {
      const button = event.target?.closest?.('button');
      if (!button || button.disabled) return;

      const text = (button.textContent || '').trim().toLowerCase();
      const title = (button.getAttribute('title') || '').trim().toLowerCase();
      const dialog = button.closest('.fixed');
      const checkboxes = dialog ? [...dialog.querySelectorAll('input[type="checkbox"]')] : [];
      let message = '';

      if (location.pathname.startsWith('/admin/website/pages/')) {
        if (title === 'delete') message = 'Delete this page section? Its content will be removed from the draft.';
        else if (text.includes('unpublish')) message = 'Unpublish this page? It will stop being available on the public website.';
      } else if (location.pathname === '/admin/website/media') {
        if (title === 'delete') message = 'Delete this media file? This cannot be undone.';
      } else if (location.pathname.startsWith('/admin/blog/')) {
        if (text.includes('unpublish')) message = 'Unpublish this article? It will disappear from the public blog.';
      } else if (location.pathname === '/admin/services' && text.includes('save service')) {
        const active = checkboxes[0];
        if (active && !active.checked) message = 'Save this service as inactive? It will no longer be available as an active service.';
      } else if (location.pathname === '/admin/departments' && text.includes('save department')) {
        const active = checkboxes[0];
        if (active && !active.checked) message = 'Save this Department as inactive? It will no longer be presented as an active Department.';
      }

      if (!message) return;
      if (!window.confirm(message)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation?.();
      }
    };

    document.addEventListener('click', protect, true);
    return () => document.removeEventListener('click', protect, true);
  }, [location.pathname]);

  return null;
};

export default DestructiveRouteGuard;
